import { Link } from "react-router-dom";

import * as Meta from 'meta';
import { ROUTE } from "route";
import { gaEvent } from "utils";
import { Footer, Header } from "components";

export const ScannedPage = () => {
  return (
    <div className="wrapper">
      <Header />
      {Meta.loadCSS(['login', 'notice'])}
      {Meta.loadJS(['main-0625'])}
      {Meta.ga("重複掃描頁")}
      <div className="main">
        <section className="login inner">
          <div className="login_iwrong"><img src="/resources/html/images/login/wrong.png" /></div>
          <div className="login_wrongtext">此QRcode已經掃描過囉</div>
          <div className="login_btbox">
            <Link to={ROUTE.SCAN} onClick={gaEvent.bind(null, '重複掃描', '繼續掃描')}><button>繼續掃描<br />QRcode</button></Link>
          </div>
        </section>
        <img className="login_left" src="/resources/html/images/intro/intro_left.png" />
        <img className="login_right" src="/resources/html/images/intro/intro_right.png" />
        <div className="other o5 ml"><img src="/resources/html/images/op2.png" /></div>
        <div className="other o6 mr"><img src="/resources/html/images/op3.png" /></div>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>
  );
};
